module.exports = __webpack_public_path__ + "FixelText-ThinItalic.4a9d0ed8e3d0c751f3a2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelText/FixelText-ThinItalic.woff2
// module id = ./src/assets/webfonts/fixelText/FixelText-ThinItalic.woff2
// module chunks = styles